/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Box,
  makeStyles,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ReactComponent as ChevronDownIcon } from '../../img/caret.svg';

import { setContactDetails } from '../../redux/user';

const useStyles = makeStyles((theme) => ({
  container: {
    border: '2px solid #cfdae2',
    borderRadius: 5,
    position: 'relative',
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  legendIcon: {
    backgroundColor: 'white',
    width: 38,
    height: 38,
    border: '2px solid lightgrey',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'lightgrey',
    position: 'absolute',
    right: 30,
    top: -19,
  },
  label: {
    fontSize: '20px',
    color: '#717271',
    top: '-15px',
  },
  phoneLabel: {
    fontSize: '20px',
    color: '#717271',
    top: '-36px',
    lineHeight: 'inherit',
    width: '370px',
    [theme.breakpoints.up('sm')]: {
      width: '603px',
    },
    [theme.breakpoints.up('md')]: {
      width: '500px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '566px',
    },
  },
  formControl: {
    marginTop: '24px',
  },
  input: {
    color: '#323232',
    fontSize: '16px',
    margiTop: '32px',
  },
  checkboxHelperText: {
    fontWeight: 'bold',
    fontSize: '10px',
    fontStyle: 'italic',
    color: '#323232',
  },
  checkboxFormControl: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  selectIcon: {
    position: 'absolute',
    left: '95%',
    top: '5px',
    zIndex: '-1000',
  },
}));

const companies = ['Movistar', 'Personal', 'Tuenti', 'Nextel', 'Claro'];

const validationSchema = Yup.object({
  insuranceName: Yup.string(),
  email: Yup.string()
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: 'Email inválido',
      }
    )
    .required('Campo obligatorio'),
  phone: Yup.string()
    .matches(/^[0-9]/, {
      message: 'Número inválido',
       excludeEmptyString: false,
     })
    .required('Campo obligatorio'),
  phoneCompany: Yup.string().required('Campo obligatorio'),
  areaCode: Yup.string().when('insuranceName', {
    is: 'AUTOMOTOR',
    then: Yup.string().matches(/^[0-9]/, {
      message: 'Número inválido',
       excludeEmptyString: false,
     }).required('Campo obligatorio'),
  }),
});

export default function PersonalInfoForm({ submitForm }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [acceptTerms, setAcceptTerms] = useState(false);

  const { contactDetails } = useSelector(({ user }) => ({
    contactDetails: user.contactDetails,
  }));

  const { insuranceName } = useSelector(({ insurances }) => ({
    insuranceName: insurances.selected.insuranceName,
  }));

  const { email, phone, phoneCompany, areaCode } = contactDetails || {};

  const initialValues = {
    email: email || '',
    phone: phone || '',
    phoneCompany: phoneCompany || '',
    areaCode: areaCode || '',
    insuranceName: insuranceName || '',
  };

  const handleOnSubmit = (values) => {
    dispatch(setContactDetails({ ...values }));
    history.push('/medios-de-pago');
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: handleOnSubmit,
    validationSchema,
  });

  function handleChange(e) {
    const key = e.target.name;
    const value = e.target.value;
    setFieldValue(key, value);
  }

  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    async function validateForm() {
      await handleSubmit();
    }
    if (!isSubmitting) {
      validateForm();
    }
  }, [submitForm]);

  const hasError = (input) => (errors[input] && touched[input] ? true : false);

  return (
    <Box classes={{ root: classes.container }}>
      <Box classes={{ root: classes.legendIcon }}>
        <img
          src={require('../../img/pencil.svg')}
          alt=''
          style={{ width: '50%' }}
        />
      </Box>
      <Box display='flex' justifyContent='center' mt='8px'>
        <Box
          component='h3'
          fontSize={{ xs: 18, sm: 22 }}
          fontWeight='fontWeightBold'
        >
          Datos de contacto
        </Box>
      </Box>
      <Box width='80%' mx='auto' mb='24px'>
        <form noValidate autoComplete='off'>
          <FormControl fullWidth classes={{ root: classes.formControl }}>
            <InputLabel
              shrink
              focused={false}
              htmlFor='email'
              classes={{ root: classes.label }}
            >
              Mail
            </InputLabel>
            <Input
              id='email'
              name='email'
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={hasError('email')}
              classes={{ root: classes.input }}
            />
            <FormHelperText error={hasError('email')}>
              {hasError('email') && errors.email}
            </FormHelperText>
          </FormControl>
          {insuranceName === 'AUTOMOTOR' ? (
            <FormControl
              fullWidth
              margin='dense'
              classes={{ root: classes.formControl }}
              style={{ marginTop: '46px' }}
            >
              <InputLabel
                shrink
                focused={false}
                htmlFor='email'
                classes={{ root: classes.phoneLabel }}
              >
                Código de área (Sin el cero)
              </InputLabel>
              <Input
                id='areaCode'
                name='areaCode'
                value={values.areaCode}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError('areaCode')}
                margin='dense'
                classes={{ root: classes.input }}
              />
              <FormHelperText error={hasError('areaCode')}>
                {hasError('areaCode') && errors.areaCode}
              </FormHelperText>
            </FormControl>
          ) : (
            ''
          )}
          {insuranceName === 'AUTOMOTOR' ? (
            <FormControl
              fullWidth
              margin='dense'
              classes={{ root: classes.formControl }}
              style={{ marginTop: '46px' }}
            >
              <InputLabel
                shrink
                focused={false}
                htmlFor='email'
                classes={{ root: classes.phoneLabel }}
              >
                Celular (Ingresá tu número sin el cero)
              </InputLabel>
              <Input
                id='phone'
                name='phone'
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError('phone')}
                margin='dense'
                classes={{ root: classes.input }}
              />
              <FormHelperText error={hasError('phone')}>
                {hasError('phone') && errors.phone}
              </FormHelperText>
            </FormControl>
          ) : (
            <FormControl
              fullWidth
              margin='dense'
              classes={{ root: classes.formControl }}
              style={{ marginTop: '46px' }}
            >
              <InputLabel
                shrink
                focused={false}
                htmlFor='email'
                classes={{ root: classes.phoneLabel }}
              >
                Celular (Por favor ingresá tu número con código de área sin el
                cero y sin el 15)
              </InputLabel>
              <Input
                id='phone'
                name='phone'
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError('phone')}
                margin='dense'
                classes={{ root: classes.input }}
              />
              <FormHelperText error={hasError('phone')}>
                {hasError('phone') && errors.phone}
              </FormHelperText>
            </FormControl>
          )}
          <FormControl fullWidth classes={{ root: classes.formControl }}>
            <InputLabel
              shrink
              focused={false}
              htmlFor='email'
              classes={{ root: classes.label }}
            >
              Compañia telefonica
            </InputLabel>
            <Select
              id='phoneCompany'
              name='phoneCompany'
              value={values.phoneCompany}
              onChange={handleChange}
              onBlur={handleBlur}
              error={hasError('phoneCompany')}
              IconComponent={() => (
                <ChevronDownIcon className={classes.selectIcon} />
              )}
            >
              {companies.map((item, key) => {
                return (
                  <MenuItem key={key} value={item}>
                    {item}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText error={hasError('phoneCompany')}>
              {hasError('phoneCompany') && errors.phoneCompany}
            </FormHelperText>
          </FormControl>
          <FormControl
            fullWidth
            margin='dense'
            classes={{ root: classes.checkboxFormControl }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                  name='terms'
                  color='primary'
                />
              }
              style={{ marginRight: 0 }}
            />
            <FormHelperText classes={{ root: classes.checkboxHelperText }}>
              Presto conformidad para la documentacion y las notificaciones por
              cambios de condiciones pactadas (nuevos conceptos y/o valores o
              reduccion de prestaciones del producto) sean remitidas al correo
              electronico consignado en la presente, en forma separada de
              cualquier otra comunicacion enviada por el Banco.
            </FormHelperText>
          </FormControl>
        </form>
      </Box>
    </Box>
  );
}
